// Etiqueta de existencias de la tienda online del súper (PR 2a; la pinta 2b).
//
// Pura: recibe lo que devuelve POST /api/online-orders/retail-stock y decide si el
// producto va «Agotado», «Quedan N» o sin etiqueta.

/** Umbral por defecto de «quedan pocas» cuando el producto no define uno. */
export const DEFAULT_LOW_STOCK_THRESHOLD = 5

export type StockBadge = { kind: "sold_out" } | { kind: "low"; left: number } | null

/**
 * `available` null = el producto no controla stock → sin etiqueta.
 * `low` cuando quedan `<= (threshold ?? 5)`; `sold_out` cuando no queda nada.
 */
export function stockBadge(available: number | null, threshold: number | null): StockBadge {
  if (available === null) return null
  if (available <= 0) return { kind: "sold_out" }
  if (available <= (threshold ?? DEFAULT_LOW_STOCK_THRESHOLD)) return { kind: "low", left: available }
  return null
}

/**
 * Unidades disponibles de un producto retail — la regla de POST
 * /api/online-orders/retail-stock, compartida con el JSON-LD en vivo de la página de producto
 * (PR 5) para que los dos digan lo mismo:
 *   - `track_stock` distinto de `true` → `null` (no controla stock);
 *   - con variantes, el stock vive en ellas: suma de las ACTIVAS (solo `is_active === false`
 *     es inactiva, igual que `isInactive`), cada una con piso 0, así que nunca es negativo;
 *     `items.current_stock` se ignora;
 *   - sin variantes, `current_stock` tal cual (null = 0). Una sobreventa puede dar negativo:
 *     la ruta lo responde así desde el PR 2a y `stockBadge` lo pinta «Agotado» con `<= 0`.
 */
export function availableUnits(
  item: { track_stock: boolean | null; has_variants: boolean | null; current_stock: number | null },
  variants: ReadonlyArray<{ current_stock: number | null; is_active: boolean | null }>,
): number | null {
  if (item.track_stock !== true) return null
  if (item.has_variants === true) {
    return variants
      .filter((v) => v.is_active !== false)
      .reduce((sum, v) => sum + Math.max(v.current_stock ?? 0, 0), 0)
  }
  return item.current_stock ?? 0
}
